/**
 * CSC collection return — preserves the last *filtered* collection URL across one
 * navigation hop and restores it on the PDP "Back to …" link.
 *
 * Supersedes assets/csc-collection-context.js (removed): that used sessionStorage
 * and stripped the query string, so filters were lost. This stashes the full
 * filtered URL in localStorage (1h TTL) and patches the snippet's static
 * [data-csc-back-link] href when it points at the same collection.
 *
 * document.referrer is empty after navigation in this theme, so localStorage —
 * not referrer — is the source of truth.
 */
(function() {
  const KEY = 'csc-last-collection-url';
  const TTL = 60 * 60 * 1000; // 1 hour

  function isCollectionPage() {
    return /^\/collections\//.test(window.location.pathname);
  }
  function hasFilter(url) {
    return /[?&](filter\.|sort_by=|page=)/.test(url);
  }
  function stash() {
    if (!isCollectionPage()) return;
    if (!hasFilter(window.location.href)) return;
    try {
      localStorage.setItem(KEY, JSON.stringify({
        url: window.location.href,
        ts: Date.now()
      }));
    } catch (e) {}
  }
  function readStash() {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (Date.now() - parsed.ts > TTL) {
        localStorage.removeItem(KEY);
        return null;
      }
      return parsed.url;
    } catch (e) { return null; }
  }
  function patchBackLink() {
    const backLink = document.querySelector('[data-csc-back-link]');
    if (!backLink) return;
    const currentHref = backLink.getAttribute('href') || '';
    if (!currentHref.startsWith('/collections/')) return;
    const collectionSlug = currentHref.split('?')[0]; // /collections/hot-tubs
    const stashedUrl = readStash();
    if (!stashedUrl) return;
    // Only restore if the stashed URL points to the same collection
    if (stashedUrl.indexOf(collectionSlug) === -1) return;
    backLink.setAttribute('href', stashedUrl);
    backLink.setAttribute('data-csc-back-restored', '1');
  }
  function run() {
    stash();
    patchBackLink();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
